export default __webpack_public_path__ + "static/simple-column-f796277e292999f3b0a457eb45b53336.png";